import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { CasesGetListParams, CasesGetListResponse, CasesGetCaseDetailsResponse } from '../types/cases.types'

export class CasesRepository {
    getCases(params: CasesGetListParams): Promise<AxiosResponse<CasesGetListResponse>> {
        return http.get('/crm/api/admin/cases', { params })
    }

    getCase(caseId: number): Promise<AxiosResponse<CasesGetCaseDetailsResponse>> {
        return http.get(`/crm/api/admin/cases/${caseId}`)
    }

    createCase(payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/crm/api/admin/cases', payload)
    }

    updateCase(caseId: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/crm/api/admin/cases/${caseId}/update`, payload)
    }

    deleteCase(caseId: number): Promise<AxiosResponse<void>> {
        return http.delete(`/crm/api/admin/cases/${caseId}`)
    }
}